import BioModal from '../Modals/BioModal';
import { cardstwo, group } from '../../images/general'
import CustomButtton from "../Button/CustomButtton";
import React, { useState } from 'react'

const StoryTabTwo = () => {
  const [isShowBio, setIsShowBio] = useState(false);
  return (
    <>
      <BioModal isVisible={isShowBio} onClose={() => setIsShowBio(false)}/>
       <div className="">
        <div className="container mx-auto flex sm:flex-row flex-col-reverse items-center">
          <div className="lg:w-[55%] sm:py-20 py-10">
            <h2 className="sm:text-7xl text-[28px] font-cinzel text-white font-bold sm:leading-[64px] leading-7 sm:mx-0 mx-auto sm:text-left text-center sm:w-full w-3/5">
               <span className="text-[#E7D4C5]">Engin </span>Altan Düzyatan
            </h2>
            <p className="sm:font-cinzel font-normal sm:text-2xl text-base sm:text-left text-center sm:leading-10 leading-8 text-white py-7">
            World Renowned Movie and TV Star Engin Altan Düzyatan As Ertuğrul Ghazi
            </p>
            <div className="sm:w-max w-9/12 sm:mx-0 mx-auto sm:mb-3 md:mb-0 mb-16">
            <CustomButtton text="Read Bio" icon2={group} onClick={() => setIsShowBio(true)}/>
            </div>
          </div>

          <div className="lg:w-full mt-6 lg:mt-0 relative hover:scale-110 transition duration-300">
            <img src={cardstwo} className="sm:w-full w-[351.72px]" />
          </div>
        </div>
      </div>
    </>
  )
}

export default StoryTabTwo
